import { defineComponent as _defineComponent } from 'vue'
import { StreamingChartsTitlesEdge } from '@/@types/graphql-types';
import ProviderIcon from '@/components/picture/ProviderIcon.vue';
import { useUserStore } from '@/helpers/composables/useStores';
import { ModalHelper } from '@/helpers/modal-helper';
import { computed } from 'vue';

interface OffersDisplayProps {
	title: StreamingChartsTitlesEdge;
	isMobile?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'OffersDisplay',
  props: {
    title: null,
    isMobile: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { title: StreamingChartsTitlesEdge, isMobile: boolean }

const { setBuyboxPresentationType } = useUserStore();


const nonCinemaOffers = computed(() => props.title.node.offers.filter(offer => offer.monetizationType !== 'CINEMA'));
const cinemaOfferCount = computed(
	() => props.title.node.offers.filter(offer => offer.monetizationType === 'CINEMA').length
);
const hasCinemaOffers = computed(() => !!props.title.node.offers.find(offer => offer.monetizationType === 'CINEMA'));
const uniquePackageIds = computed(() => [
	...new Set(nonCinemaOffers.value.map(offer => offer.package?.packageId).filter(Boolean)),
]);
const displayedPackageIds = computed(() => uniquePackageIds.value.slice(0, props.isMobile ? 6 : 3));
const openBuyboxModal = async () => {
	const { default: WatchNowModal } = await import('@/components/modals/WatchNowModal.vue');
	setBuyboxPresentationType({ presentationType: null });
	ModalHelper.openModal(WatchNowModal, {
		title: props.title.node,
	});
};
const displayMoreOffers = computed(() => {
	return (
		uniquePackageIds.value.length - (props.isMobile ? 6 : 3) > 0 ||
		(hasCinemaOffers.value && cinemaOfferCount.value > 0)
	);
});
const moreOffersCount = computed(() => {
	return hasCinemaOffers.value && uniquePackageIds.value.length - (props.isMobile ? 6 : 3) <= 0
		? cinemaOfferCount.value
		: uniquePackageIds.value.length -
				(props.isMobile ? 6 : 3) +
				(hasCinemaOffers.value ? cinemaOfferCount.value : 0);
});

return { __sfc: true,setBuyboxPresentationType, props, nonCinemaOffers, cinemaOfferCount, hasCinemaOffers, uniquePackageIds, displayedPackageIds, openBuyboxModal, displayMoreOffers, moreOffersCount, ProviderIcon }
}

})